// extracted by mini-css-extract-plugin
module.exports = {"formContainer":"delivery_formContainer__19zPI"};